import {
	trigger, state, style, transition,
	animate, group, query
} from '@angular/animations';

export const SlideInOutAnimation = [
	trigger('slideInOut', [
		state('in', style({
			'max-height': '200px', 'opacity': '1', 'visibility': 'visible'
		})),
		state('out', style({
			'max-height': '0px', 'opacity': '0', 'visibility': 'hidden'
		})),
		transition('in => out', [group([
			animate('400ms ease-in-out', style({
				'opacity': '0'
			})),
			animate('600ms ease-in-out', style({
				'max-height': '0px'
			})),
			animate('700ms ease-in-out', style({
				'visibility': 'hidden'
			})),
		]
		)]),
		transition('out => in', [group([
			animate('1ms ease-in-out', style({
				'visibility': 'visible'
			})),
			animate('600ms ease-in-out', style({
				'max-height': '500px'
			})),
			animate('500ms ease-in-out', style({
				'opacity': '1'
			}))

		]
		)])
	]),
];
export const SlideDownAnimation = [
	trigger('slidedown', [
		state('in', style({
			'max-height': '200px', 'opacity': '1', 'visibility': 'visible'
		})),
		state('out', style({
			'max-height': '0px', 'opacity': '0', 'visibility': 'hidden'
		})),
		transition('in => out', [group([
			animate('700ms ease-in-out', style({
				'opacity': '0'
			})),
			animate('400ms ease-in-out', style({
				'max-height': '0px'
			})),
			animate('700ms ease-in-out', style({
				'visibility': 'hidden'
			})),
		]
		)]),
		transition('out => in', [group([
			animate('1ms ease-in-out', style({
				'visibility': 'visible'
			})),
			animate('900ms ease-in-out', style({
				'max-height': '500px'
			})),
			animate('400ms ease-in-out', style({
				'opacity': '1'
			}))

		]
		)])
	]),
];
export const sidebarExpandAnimation = [
	trigger('slideInOut', [
		state('0', style({
			height: '0px',
			overflow: 'hidden'
		})),
		state('1', style({
			height: '*',
			overflow: 'hidden'
		})),
		transition('1 => 0', animate('250ms ease-out')),
		transition('0 => 1', animate('250ms ease-in'))
	]),
];
export const SlideRightAnimation = [
	trigger('slideRight', [
		state('1', style({
			transform: 'translateX(-100%)'
		})),
		state('0', style({
			transform: 'translateX(0)'
		})),
		transition('1 => 0', animate('300ms ease-out')),
		transition('0 => 1', animate('300ms ease-in'))
	]),
];
// scale 2
export const RoutingAnimation =
	trigger('routeAnimations', [
		transition('* => *', [
			query(':enter, :leave',
				style({ position: 'absolute', width: '100%' }),
				{ optional: true }),
			group([
				query(':enter', [
					style({ transform: 'scale(.99)', opacity: '0' }),
					animate('.1s ease-in-out',
						style({ transform: 'scale(1)', opacity: '.5' }))
				], { optional: true }),
				query(':leave', [
					style({ transform: 'scale(0)', opacity: '.5' }),
					animate('.1s ease-in-out',
						style({ transform: 'scale(0)', opacity: '0' }))
				], { optional: true }),
			])
		]),
	]);

export const SlideLeft = [
	query(':enter, :leave', style({ position: 'fixed', width: '200px' }), { optional: true }),
	group([
		query(':enter', [style({ transform: 'translateX(-200px)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
			optional: true,
		}),
		query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(200px)' }))], {
			optional: true,
		}),
	]),
];

export const SlideRight = [
	query(':enter, :leave', style({ position: 'fixed', width: '200px' }), { optional: true }),
	group([
		query(':enter', [style({ transform: 'translateX(200px)' }), animate('.3s ease-out', style({ transform: 'translateX(0%)' }))], {
			optional: true,
		}),
		query(':leave', [style({ transform: 'translateX(0%)' }), animate('.3s ease-out', style({ transform: 'translateX(-200px)' }))], {
			optional: true,
		}),
	]),
];

export const animImageSlider = {

}









